import { Box, Typography } from "@mui/material";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import { ORDER_STATUS_EXPIRED } from "../constants";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import { FlexVerticalAligned } from "../../../common/components/styled/styled";

type Props = {
  mainStatus: string;
};

export const StatusBanner = ({ mainStatus }: Props) => {
  const { t } = useTranslation("order");
  const isOrderExpired = mainStatus === ORDER_STATUS_EXPIRED;

  return isOrderExpired ? (
    <Box
      p={0.5}
      pl={4}
      m={-2}
      mb={2}
      sx={{
        backgroundColor: theme.palette.gray.primary,
      }}
    >
      <FlexVerticalAligned gap={1}>
        <Typography color={theme.palette.common.black}>
          {t("orderExpired")}
        </Typography>
        <InfoTooltip
          title={t("orderExpiredInfo")}
          style={{ color: theme.palette.common.black }}
        />
      </FlexVerticalAligned>
    </Box>
  ) : null;
};
